import { useStoreInfo } from "../../../hooks/storeInfoHooks/useStoreInfo";
import { FaXTwitter } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setCountry } from "../../../store/slices/country-slice";
import { getPhoneByCountry } from "../../../helpers/countryHelper";

const MobileWidgets = () => {
  const { data: storeInfo, isLoading: isLoadingStoreInfo } = useStoreInfo();
  const { selectedCountry, countries } = useSelector((state) => state.country);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const countryPhone = getPhoneByCountry(storeInfo?.[0], selectedCountry);

  const handleCountryChange = (countryId) => {
    dispatch(setCountry(countryId));
  };

  return (
    <div className="offcanvas-widget-area mt-5">
      {/* Country Selector */}
      <div className="off-canvas-country-widget mb-4">
        <h4 className="mb-3" style={{ fontSize: "16px", fontWeight: "600" }}>
          {i18n.resolvedLanguage === "ar" ? "اختر الدولة" : "Select Country"}
        </h4>
        <div className="d-flex gap-2 flex-wrap">
          {countries.map((country) => (
            <button
              key={country.id}
              onClick={() => handleCountryChange(country.id)}
              className={`btn btn-sm ${
                selectedCountry === country.id
                  ? "btn-primary"
                  : "btn-outline-secondary"
              }`}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                fontSize: "14px",
                fontWeight: selectedCountry === country.id ? "600" : "400",
              }}
            >
              {country.flag}{" "}
              {i18n.resolvedLanguage === "ar" ? country.name : country.nameEn}
            </button>
          ))}
        </div>
      </div>
      <div className="off-canvas-contact-widget">
        <div className="header-contact-info">
          <ul>
            <li>
              <i className="fa fa-phone fs-5"></i>
              <a
                href={`tel:${countryPhone}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {countryPhone}{" "}
              </a>
            </li>
            <li>
              <i className="fa fa-envelope fs-5"></i>
              <a
                href={`mailto:${storeInfo?.[0]?.email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                {storeInfo?.[0]?.email}
              </a>
            </li>
            <li>
              {" "}
              <i className="fa fa-map fs-5"></i>
              <a href={"/"}>{storeInfo?.[0]?.address}</a>
            </li>
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      <div className="d-flex align-items-center gap-3 footer-list flex-wrap justify-content-center">
        {storeInfo?.[0]?.facebook && (
          <a href={storeInfo?.[0]?.facebook} target="_blank">
            <FaFacebookF size={20}></FaFacebookF>
          </a>
        )}
        {storeInfo?.[0]?.twitter && (
          <a href={storeInfo?.[0]?.twitter} target="_blank">
            <FaXTwitter size={20}></FaXTwitter>
          </a>
        )}
        {storeInfo?.[0]?.youtube && (
          <a href={storeInfo?.[0]?.youtube} target="_blank">
            <IoLogoYoutube size={20}></IoLogoYoutube>
          </a>
        )}
        {storeInfo?.[0]?.instagram && (
          <a href={storeInfo?.[0]?.instagram} target="_blank">
            <FaInstagram size={20}></FaInstagram>
          </a>
        )}
        {storeInfo?.[0]?.whatsapp && (
          <a href={storeInfo?.[0]?.whatsapp} target="_blank">
            <FaWhatsapp size={20}></FaWhatsapp>
          </a>
        )}
      </div>
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
